/**
 * A one-line confirmation of something the operator just did ("Schedule
 * updated"), said once where the eye already is and gone after a few
 * seconds. Not the alert toast stack (`ToastStack`), which is the
 * building talking and is held, counted and acknowledged; this is the
 * console answering a click, and nothing about it needs keeping.
 */
import { useEffect } from 'react';
import './ScheduleEditDrawer.css';

export function ActionToast({
  message,
  onDone,
  ms = 4000,
}: {
  message: string;
  onDone: () => void;
  ms?: number;
}) {
  useEffect(() => {
    const t = window.setTimeout(onDone, ms);
    return () => window.clearTimeout(t);
  }, [onDone, ms]);
  return (
    <div className="nx-action-toast" role="status" data-testid="action-toast">
      {message}
    </div>
  );
}
